export default __webpack_public_path__ + "static/thumb-landscape-2e1086e4e7055e15fb52a91ebdd87211.jpg";